import { render, staticRenderFns } from "./MclaseModals.vue?vue&type=template&id=0460e463"
import script from "./MclaseModals.vue?vue&type=script&lang=js"
export * from "./MclaseModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports